// Utility to adapt form data for API submission
import moment from "moment";

export const prepareLegajoForSave = (formData, uuid) => {
  const dataToSend = {
    datosPersonales: {
      ...formData.datosPersonales,
      uuid_foto: uuid,
      activo: formData.datosPersonales.fecha_baja ? 0 : 1,
    },
    datosLaborales: {
      ...formData.datosLaborales,
      empleado_cuil: formData.datosPersonales.cuil,
    },
    familiares: (formData.familiares || []).map((f) => ({
      ...f,
      fecha_nacimiento: f.fecha_nacimiento
        ? moment(f.fecha_nacimiento).format("YYYY-MM-DD")
        : null,
    })),
    telefonosEmpleado: formData.telefonosEmpleado,
  };

  // Formatting dates
  ["fecha_ingreso", "fecha_baja", "fecha_nacimiento"].forEach((field) => {
    if (dataToSend.datosPersonales[field]) {
      dataToSend.datosPersonales[field] = moment(dataToSend.datosPersonales[field]).format(
        "YYYY-MM-DD"
      );
    } else if (field === "fecha_baja") {
      dataToSend.datosPersonales[field] = null;
    }
  });

  return dataToSend;
};

export const hasTabErrors = (tabValue, errors) => {
  if (tabValue === "personal") {
    return Object.keys(errors).some((k) =>
      [
        "cuil",
        "nombre",
        "apellido",
        "email",
        "nro_doc",
        "nro_legajo",
        "fecha_ingreso",
        "id_tipo_doc",
        "id_provincia",
        "id_localidad",
        "telefonosEmpleado",
        "xdistancia"
      ].includes(k)
    );
  }
  if (tabValue === "laboral") {
    return Object.keys(errors).some((k) =>
      [
        "sucursal_id",
        "puesto_id",
        "sector_id",
        "banco_id",
        "nro_cuenta",
        "cbu",
        "alias"
      ].includes(k)
    );
  }
  if (tabValue === "familiares") {
    return !!errors.familiares;
  }
  return false;
};
